// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBq76y-nEoYxEIAJpBr758MAFR506tgSes",
  authDomain: "pet-nft.firebaseapp.com",
  databaseURL: "https://pet-nft-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "pet-nft",
  storageBucket: "pet-nft.firebasestorage.app",
  messagingSenderId: "104544946404",
  appId: "1:104544946404:web:944726fa7085885af6c4f1",
  measurementId: "G-1RP6V9EPF8"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);